export default __webpack_public_path__ + "static/media/ROX_4996.e6bbde62.jpg";